import { useMutation, useQueryClient } from 'react-query';
import { useExaminationApiContext } from '@higo/common/src/features/ExaminationPage/providers';
import { toast } from 'react-toastify';
import { editOrCloseVisit } from '@higo/api/lib/services/examinationService';

export const useEditOrCloseVisitMutation = (id: number) => {
  const axiosInstance = useExaminationApiContext();

  return useMutation(
    (status: string) => editOrCloseVisit(axiosInstance)(id, status),
    {
      onSuccess: () => {
        toast.success('The visit has been successfully ended');
      },
    },
  );
};
